/* Click a colour dot on a product card to swap that card's photo, link and
   colour label in place, without leaving the page. Ziyad's explicit choice
   (2026-09-23): cutsclothing.com navigates away on click, this store does not.
   Delegated from document so it covers cards added later by paginated or
   filtered collection loads. */
(function () {
  if (window.__rwCardSwatchInit) return;
  window.__rwCardSwatchInit = true;

  document.addEventListener(
    'click',
    function (event) {
      var swatch = event.target.closest && event.target.closest('.rw-card-swatch');
      if (!swatch) return;

      var group = swatch.closest('.rw-card-swatches');
      var card = swatch.closest('.card-wrapper');
      if (!group || !card) return;

      event.preventDefault();
      event.stopPropagation();

      group.querySelectorAll('.rw-card-swatch').forEach(function (s) {
        s.classList.remove('rw-card-swatch--current');
        s.removeAttribute('aria-current');
      });
      swatch.classList.add('rw-card-swatch--current');
      swatch.setAttribute('aria-current', 'true');

      var imgs = card.querySelectorAll('.card__media img.motion-reduce');
      if (imgs[0] && swatch.dataset.img) {
        imgs[0].removeAttribute('srcset');
        imgs[0].src = swatch.dataset.img;
        if (swatch.dataset.alt) imgs[0].alt = swatch.dataset.alt;
      }
      if (imgs[1]) {
        if (swatch.dataset.img2) {
          imgs[1].removeAttribute('srcset');
          imgs[1].src = swatch.dataset.img2;
          imgs[1].style.display = '';
        } else {
          imgs[1].style.display = 'none';
        }
      }

      card.querySelectorAll('a[href]').forEach(function (link) {
        if (link.classList.contains('rw-card-swatch')) return;
        if (swatch.dataset.url) link.href = swatch.dataset.url;
      });

      var label = card.querySelector('.rw-card-swatches__label');
      if (label && swatch.dataset.colour) label.textContent = swatch.dataset.colour;
    },
    true
  );
})();
